
export const lowerCaseFirst = (text: string) => {
	return text.slice(1) ? text[0].toLowerCase() + text.slice(1) : text.toLowerCase();
}
